import { render } from "./OuterContentsFile.vue?vue&type=template&id=88144dfc&scoped=true&ts=true"
import script from "./OuterContentsFile.vue?vue&type=script&lang=ts"
export * from "./OuterContentsFile.vue?vue&type=script&lang=ts"

import "./OuterContentsFile.vue?vue&type=style&index=0&id=88144dfc&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3320913318/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88144dfc"]])

export default __exports__